module.exports = __webpack_public_path__ + "img/star.c2637ef9.gif";